import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '../StyledComponents/StyledComponents';

const PrimaryButton = (props) => {
    const { i18n } = useTranslation();
    const language = i18n.language || 'en';

    // If it's an external link, use as-is
    if (props.route && props.route.startsWith('http')) {
        return (
            <a href={props.route} target={props.newTab ? '_blank' : null}>
                <Button
                    color={props.color}
                    onClick={props.onClick}
                    type={props.submit ? 'submit' : 'button'}
                    right={props.right ? true : false}
                    left={props.left ? true : false}
                >
                    {props.left ? <i className="las la-arrow-left"></i> : null}
                    <span>{props.text}</span>
                    {props.right ? (
                        <i
                            className={`las la-${props.newTab ? 'level-up-alt' : 'arrow-right'}`}
                        ></i>
                    ) : null}
                </Button>
            </a>
        );
    }

    const basePath = `${process.env.PUBLIC_URL || ''}/${language}`;

    // For internal routes, prepend /<lang> after the blog base
    let route = `${basePath}`;
    if (props.route) {
        if (props.route.startsWith('/')) {
            route = `${basePath}${props.route}`;
        } else {
            // Assume it's a post slug
            route = `${basePath}/posts/${props.route}`;
        }
    }

    return (
        <a href={route} target={props.newTab ? '_blank' : null}>
            <Button
                color={props.color}
                onClick={props.onClick}
                type={props.submit ? 'submit' : 'button'}
                right={props.right ? true : false}
                left={props.left ? true : false}
            >
                {props.left ? <i className="las la-arrow-left"></i> : null}
                <span>{props.text}</span>
                {props.right ? (
                    <i
                        className={`las la-${props.newTab ? 'level-up-alt' : 'arrow-right'}`}
                    ></i>
                ) : null}
            </Button>
        </a>
    );
};

export default PrimaryButton;
